import { render, staticRenderFns } from "./BillPaymentsHistory.vue?vue&type=template&id=604bfbd9"
import script from "./BillPaymentsHistory.vue?vue&type=script&lang=js"
export * from "./BillPaymentsHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports